<template>
  <div class="chat-box">
    <div class="chat-container">
      <div class="chat-header">
        <div>
          {{ conversationName || "" }}
        </div>
      </div>
      <div class="chat-list-box" id="chatListScroll">
        <el-empty description="请选择会话" v-if="!conversation.imConversationID"></el-empty>
        <chatList
          ref="messageList"
          @toBottom="toBottom"
          :conversation="conversation"
        />
      </div>
      <div class="chat-input-box">
        <chatInput
          ref="messageInput"
          @openTool="openToolPop"
          :conversation="conversation"
          @sendMessage="sendMessage"
        />
      </div>
    </div>

    <expertSearch ref="search" @send="sendCoach"></expertSearch>
  </div>
</template>

<script>
import chatList from "./chat-list/index.vue";
import chatInput from "./chat-input/index.vue";
import expertSearch from "./expertSearch/expertSearch.vue";
export default {
  components: {
    chatList,
    chatInput,
    expertSearch
  },
  props: {
    conversation: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      conversationName: "",
    };
  },
  watch: {
    conversation: {
      handler: function (conversation) {
        // 计算时间戳
        this.conversationName = this.getConversationName(conversation);
        this.$tim.setMessageRead({conversationID : conversation.conversationID});
			
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.$tim.on(this.$tims.EVENT.MESSAGE_RECEIVED, this.$onMessageReceived);
  },
  destroyed() {
    this.$tim.on(this.$tims.EVENT.MESSAGE_RECEIVED, this.$onMessageReceived);
  },
  methods: {
    sendCoach(coach){
      let msg = {
						data: 'expert',
						description: '心悦教练',
						extension: JSON.stringify({
							id:coach.id,
							coach_type: coach.coach_type,
							city: coach.city,
							head_portrait: coach.head_portrait,
							teaching_categories: coach.teaching_categories,
							name: coach.name,
							min_price: coach.min_price
						})
					}

      this.$refs.messageInput.sendCustomMessage(msg)
    },
    openToolPop(v){
      this.$refs.search.open()
    },
    toBottom(ele) {
        var container = document.querySelector("#chatListScroll");
        container.scrollTop = ele.scrollTop;
    },

    sendMessage(message) {
      this.$refs.messageList.updateMessageList(message);
    },

    // 收到的消息
    $onMessageReceived(value) {
      // 若需修改消息，需将内存的消息复制一份，不能直接更改消息，防止修复内存消息，导致其他消息监听处发生消息错误
      const event = value;
      if (!this.conversation.imConversationID) {
        return;
      }
      event.data.forEach((item) => {
        if (item.imConversationID === this.conversation.imConversationID) {
          this.$refs.messageList.updateMessageList(Object.assign(item));
        }
      });
    },
    getConversationName(conversation) {
      if (!conversation.type) {
        return;
      }

      if (conversation.type === "C2C") {
        return (
          conversation.remark ||
          conversation.userProfile.nick ||
          conversation.userProfile.userID
        );
      } else if (conversation.type === "GROUP") {
        return (
          conversation.groupProfile.name || conversation.groupProfile.groupID
        );
      } else {
        return conversation.userProfile.nick || "用户";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.chat-box {
  width: 100%;
  height: 100%;
}
.chat-header {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 15px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .chat-list-box {
    flex: 1;
    overflow-y: scroll;
  }
  .chat-input-box {
    // height: 300px;
    flex-shrink: 0;
  }
}
</style>